// extracted by mini-css-extract-plugin
export var closeButton = "_qi-2";
export var closeButtonIcon = "_qi-3";
export var lightboxContent = "_qi-1";
export var lightboxOverlay = "_qi-0";